const TOKEN = /dd?|DD?|mm?|MM?|yy?(?:yy)?/g

const pad = (n, length) => String(n).padStart(length, '0')

const formatters = {
  d: (date) => date.getDate(),
  dd: (date) => pad(date.getDate(), 2),
  D: (date, locale) => locale.daysShort[date.getDay()],
  DD: (date, locale) => locale.days[date.getDay()],
  m: (date) => date.getMonth() + 1,
  mm: (date) => pad(date.getMonth() + 1, 2),
  M: (date, locale) => locale.monthsShort[date.getMonth()],
  MM: (date, locale) => locale.months[date.getMonth()],
  y: (date) => date.getFullYear(),
  yy: (date) => pad(date.getFullYear(), 2).slice(-2),
  yyyy: (date) => pad(date.getFullYear(), 4),
}

export function formatDate(date, format, locale) {
  return format.replace(TOKEN, (token) =>
    (formatters[token] || formatters.y)(date, locale),
  )
}

const startsName = (names, word) =>
  names.findIndex((name) => name.toLowerCase().startsWith(word))

function monthIndex(word, locale) {
  if (word.length < 3) return -1
  const short = startsName(locale.monthsShort, word)
  return short >= 0 ? short : startsName(locale.months, word)
}

const isWeekday = (word, locale) =>
  word.length >= 2 &&
  (startsName(locale.days, word) >= 0 ||
    startsName(locale.daysShort, word) >= 0)

function buildDate(year, month, day) {
  if (!/^\d{1,4}$/.test(year) || !/^\d{1,2}$/.test(day)) return NaN
  const y = year.length <= 2 ? 2000 + Number(year) : Number(year)
  const d = Number(day)
  if (year.length === 3 || month < 0 || month > 11 || d < 1) return NaN
  const date = new Date(y, month, d)
  return date.getMonth() === month && date.getDate() === d ? date : NaN
}

export function parseDate(text, format, locale) {
  const value = String(text).trim().toLowerCase()
  const iso = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/)
  if (iso) return buildDate(iso[1], Number(iso[2]) - 1, iso[3])

  const words = value.split(/[\s,./-]+/).filter(Boolean)
  const numbers = []
  let month = null
  for (const word of words) {
    if (/^\d+$/.test(word)) {
      numbers.push(word)
    } else if (month === null && monthIndex(word, locale) >= 0) {
      month = monthIndex(word, locale)
    } else if (!isWeekday(word, locale)) {
      return NaN
    }
  }

  if (month !== null) {
    if (numbers.length !== 2) return NaN
    const [day, year] =
      numbers[0].length === 4 ? [numbers[1], numbers[0]] : numbers
    return buildDate(year, month, day)
  }

  if (numbers.length !== 3) return NaN
  if (numbers[0].length === 4)
    return buildDate(numbers[0], Number(numbers[1]) - 1, numbers[2])
  const monthFirst = format.search(/m/i) < format.search(/d/)
  const [m, d] = monthFirst ? numbers : [numbers[1], numbers[0]]
  if (!/^\d{1,2}$/.test(m)) return NaN
  return buildDate(numbers[2], Number(m) - 1, d)
}

export function lenientFormat(format) {
  return {
    toDisplay: (date, _format, locale) => formatDate(date, format, locale),
    toValue: (text, _format, locale) => parseDate(text, format, locale),
  }
}
